module.exports = __webpack_public_path__ + "static/media/mobile_capy_page_area04_img_en@2x.54120b27.png";